import styles from "./SidebarSpacer.module.css";

/**
 * Flexible gap that pushes everything after it to the bottom of the rail.
 *
 * Replaces `SidebarSpace` from `@backstage/core-components`.
 */
export const SidebarSpacer = () => <div className={styles.root} />;
